export default "__VITE_ASSET__BdT1rEoc__"